import { fetchFactory } from 'isotope-client'
import { getFormattedUrl } from '../../../utils/fetchDownload'
import { PaginateRequestStockFiltersModel } from '../..//admin/stock/services/stockModel'

export const getVaccinationStockPageMobile = (filters: PaginateRequestStockFiltersModel) => fetchFactory(`${getFormattedUrl('/vaccination/stock', filters)}&page=${filters.page}&size=5`)

export const getVaccinationStockList = () => fetchFactory('/vaccination/stock/list')
